/**
 * Registre des tours guidés, indexé par `TourId`.
 *
 * @remarks
 * `Record<TourId, …>` est exhaustif : ajouter un id dans `TOUR_IDS` sans
 * déclarer son tour ici ne compile pas. Le contrôleur (`use-guided-tour`) ne
 * connaît que ce registre — jamais un tour en particulier.
 */

import { APP_OVERVIEW_TOUR } from './app-overview-steps';
import { EVALUATION_TOUR } from './evaluation-steps';
import type { TourDefinition, TourId } from './tour-types';

const TOURS: Record<TourId, TourDefinition> = {
  evaluation: EVALUATION_TOUR,
  'app-overview': APP_OVERVIEW_TOUR,
};

export function getTour(id: TourId): TourDefinition {
  return TOURS[id];
}
